import { Injectable, OnDestroy } from '@angular/core';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { Settings } from '@stockcare-helpers/settings';
import { filter, switchMap } from 'rxjs/operators';
import { Subject, Subscription, interval, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WhiteboardRefreshService implements OnDestroy {
  private whiteboardRefreshInterval = new Subject();
  private whiteboardNeedsToBeRefreshedSubject = new Subject<boolean>();
  subscriptions = new Subscription();

  constructor(private settingsService: SettingsService) {}

  initialize() {
    console.log('Starting whiteboard refresh service');
    this.subscribeToSettingsChanged();
    this.startPolling();
    this.getSettings();
  }

  private subscribeToSettingsChanged() {
    this.settingsService.settingsUpdated
      .pipe(
        filter((settings) =>
          this.settingsService.hasSettingBeenUpdated(
            Settings.WHITEBOARD_REFRESH_INTERVAL,
            settings
          )
        )
      )
      .subscribe(() => {
        this.getSettings();
      });
  }

  private getSettings() {
    const whiteboardRefreshIntervalSetting =
      this.settingsService.getSettingValue(
        Settings.WHITEBOARD_REFRESH_INTERVAL
      ) * 1000;

    this.whiteboardRefreshInterval.next(whiteboardRefreshIntervalSetting);
  }

  private startPolling() {
    this.whiteboardRefreshInterval
      .pipe(
        switchMap((whiteboardRefreshIntervalSetting: number) =>
          interval(whiteboardRefreshIntervalSetting)
        )
      )
      .subscribe(() => this.whiteboardNeedsToBeRefreshedSubject.next(true));
  }

  whiteboardNeedsToBeRefreshed(): Observable<boolean> {
    return this.whiteboardNeedsToBeRefreshedSubject.asObservable();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
